/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  SECURE_MESSAGING_DROPDOWN_OPTION_ARMLOAN: 'secure.messaging.dropdown.option.armloan',
  SECURE_MESSAGING_DROPDOWN_OPTION_ASSUMPTION: 'secure.messaging.dropdown.option.assumption',
  SECURE_MESSAGING_DROPDOWN_OPTION_AUTODRAFTING: 'secure.messaging.dropdown.option.autodrafting',
  SECURE_MESSAGING_DROPDOWN_OPTION_BANKRUPTCYFORCLOSURE: 'secure.messaging.dropdown.option.bankruptcyforclosure',
  SECURE_MESSAGING_DROPDOWN_OPTION_BISAVERPROGRAM: 'secure.messaging.dropdown.option.bisaverprogram',
  SECURE_MESSAGING_DROPDOWN_OPTION_COUPONREQUEST: 'secure.messaging.dropdown.option.couponrequest',
  SECURE_MESSAGING_DROPDOWN_OPTION_COVID19HARDSHIPREQUEST: 'secure.messaging.dropdown.option.covid19hardshiprequest',
  SECURE_MESSAGING_DROPDOWN_OPTION_CREDITREPORTING: 'secure.messaging.dropdown.option.creditreporting',
  SECURE_MESSAGING_DROPDOWN_OPTION_DELINQUENTPAYMENT: 'secure.messaging.dropdown.option.delinquentpayment',
  SECURE_MESSAGING_DROPDOWN_OPTION_ESCROWANALYSIS: 'secure.messaging.dropdown.option.escrowanalysis',
  SECURE_MESSAGING_DROPDOWN_OPTION_HAZARDINSURANCE: 'secure.messaging.dropdown.option.hazardinsurance',
  SECURE_MESSAGING_DROPDOWN_OPTION_LATECHARGES: 'secure.messaging.dropdown.option.latecharges',
  SECURE_MESSAGING_DROPDOWN_OPTION_LOSSDRAFT: 'secure.messaging.dropdown.option.lossdraft',
  SECURE_MESSAGING_DROPDOWN_OPTION_LOSTMISAPPLIEDPAYMENT: 'secure.messaging.dropdown.option.lostmisappliedpayment',
  SECURE_MESSAGING_DROPDOWN_OPTION_OPTIONALINSURANCE: 'secure.messaging.dropdown.option.optionalinsurance',
  SECURE_MESSAGING_DROPDOWN_OPTION_OTHER: 'secure.messaging.dropdown.option.other',
  SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFRELEASEDOC: 'secure.messaging.dropdown.option.payoffreleasedoc',
  SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFSTATEMENT: 'secure.messaging.dropdown.option.payoffstatement',
  SECURE_MESSAGING_DROPDOWN_OPTION_PMICANCELLATION: 'secure.messaging.dropdown.option.pmicancellation',
  SECURE_MESSAGING_DROPDOWN_OPTION_PMIINSURANCE: 'secure.messaging.dropdown.option.pmiinsurance',
  SECURE_MESSAGING_DROPDOWN_OPTION_PROMISETOPAY: 'secure.messaging.dropdown.option.promisetopay',
  SECURE_MESSAGING_DROPDOWN_OPTION_REFINANCE: 'secure.messaging.dropdown.option.refinance',
  SECURE_MESSAGING_DROPDOWN_OPTION_REGULARPAYMENT: 'secure.messaging.dropdown.option.regularpayment',
  SECURE_MESSAGING_DROPDOWN_OPTION_STATEMENTCOUPON: 'secure.messaging.dropdown.option.statementcoupon',
  SECURE_MESSAGING_DROPDOWN_OPTION_TAXES: 'secure.messaging.dropdown.option.taxes',
  SECURE_MESSAGING_DROPDOWN_OPTION_UPDATEPERSONALINFORMATION: 'secure.messaging.dropdown.option.updatepersonalinformation',
  SECURE_MESSAGING_DROPDOWN_OPTION_YEAREND1098: 'secure.messaging.dropdown.option.yearend1098',
  SECURE_MESSAGING_HELP_PAGE_TEXT: 'secure.messaging.help.page.text',
  SECURE_MESSAGING_NO_MESSAGE_TEXT: 'help.secure.mesaging.no.message.text',
};

const enMessages = {
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ARMLOAN]: 'ARM Loan',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ASSUMPTION]: 'Assumption',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_AUTODRAFTING]: 'Auto Drafting',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_BANKRUPTCYFORCLOSURE]: 'Bankruptcy/Foreclosure',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_BISAVERPROGRAM]: 'Bi-Saver Program',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_COUPONREQUEST]: 'Coupon Request',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_COVID19HARDSHIPREQUEST]: 'COVID19 Hardship Request',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_CREDITREPORTING]: 'Credit Reporting',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_DELINQUENTPAYMENT]: 'Delinquent Payment',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ESCROWANALYSIS]: 'Escrow Analysis',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_HAZARDINSURANCE]: 'Hazard Insurance',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LATECHARGES]: 'Late Charge(s)',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LOSSDRAFT]: 'Loss Draft',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_LOSTMISAPPLIEDPAYMENT]: 'Lost/Misapplied Payment',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_OPTIONALINSURANCE]: 'Optional Insurance',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_OTHER]: 'Other',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFRELEASEDOC]: 'Payoff Release Doc',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFSTATEMENT]: 'Payoff Statement',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PMICANCELLATION]: 'PMI Cancellation',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PMIINSURANCE]: 'PMI Insurance',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PROMISETOPAY]: 'Promise to Pay',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_REFINANCE]: 'Refinance',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_REGULARPAYMENT]: 'Regular Payment',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_STATEMENTCOUPON]: 'Statement/Coupon',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_TAXES]: 'Taxes',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_UPDATEPERSONALINFORMATION]: 'Update Personal Information',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_YEAREND1098]: 'Year-End 1098',
  [IDS.SECURE_MESSAGING_HELP_PAGE_TEXT]: 'Secure messaging is a convenient and easy way to contact customer service about your loan.',
  [IDS.SECURE_MESSAGING_NO_MESSAGE_TEXT]: 'You haven\'t submitted any inquiries yet. Secure messaging is a convenient and easy way to contact customer service about your loan. Get started here.',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_ARMLOAN]: 'ARM Account',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFRELEASEDOC]: 'Discounted Murabaha Debt/Payoff Release Doc',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_PAYOFFSTATEMENT]: 'Discounted Murabaha Debt/Payoff Statement',
  [IDS.SECURE_MESSAGING_DROPDOWN_OPTION_REFINANCE]: 'Replacement of Murabaha Contract',
  [IDS.SECURE_MESSAGING_HELP_PAGE_TEXT]: 'Secure messaging is a convenient and easy way to contact customer service about your account.',
  [IDS.SECURE_MESSAGING_NO_MESSAGE_TEXT]: 'You haven\'t submitted any inquiries yet. Secure messaging is a convenient and easy way to contact customer service about your account. Get started here.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
